<div class="steps" [ngSwitch]="step">
  <div *ngSwitchCase="0" class="step">
    <h1 class="step-title">
      <b>Não tem acesso ao aplicativo?</b> <br>
      Utilize o formulário abaixo para encontrar seu cadastro
    </h1>
    <form [formGroup]="formLogin" autocomplete="off" class="form-login" (ngSubmit)="SubitLogin()">
      <div class="double">
        <!-- Nome completo -->
        <div class="input-wrapper">
          <label for="nomeCompleto">Nome completo:</label>
          <input autocomplete="false" autocomplete="chrome-off" class="form-control mt-1" id="nomeCompleto"
            formControlName="nomeCompleto" type="text" placeholder="Nome completo">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formLogin.controls.nomeCompleto.errors?.required && submitErrado">
            Campo obrigatório
          </span>
        </div>

        <!-- Nome da Mãe -->
        <div class="input-wrapper">
          <label for="nomeMae">Nome da mãe (completo):</label>
          <input autocomplete="false" autocomplete="chrome-off" class="form-control mt-1" id="nomeMae"
            formControlName="nomeMae" type="text" placeholder="Nome da mãe (completo)">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formLogin.controls.nomeMae.errors?.required && submitErrado">
            Campo obrigatório
          </span>
        </div>
      </div>

      <div class="double">
        <!-- Data de Nascimento -->
        <div class="input-wrapper">
          <label for="data_nascimento">Data de nascimento:</label>
          <input autocomplete="false" autocomplete="chrome-off" class="form-control mt-1" id="data_nascimento"
            formControlName="data_nascimento" type="date" placeholder="DD/MM/AAAA">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formLogin.controls.data_nascimento.errors?.required && submitErrado">
            Campo obrigatório
          </span>
          <span style="color: red; font-size: 11pt;"
            *ngIf="formLogin.controls.data_nascimento.errors?.birthDate && submitErrado">
            A data de nascimento deve ser anterior a data atual
          </span>

        </div>

        <!-- CPF -->
        <div class="input-wrapper">
          <label for="cpf">CPF:</label>
          <input autocomplete="false" autocomplete="chrome-off" class="form-control mt-1"
            [dropSpecialCharacters]="false" mask="000.000.000-00" id="cpf" formControlName="cpf" type="text"
            placeholder="CPF">
          <span style="color: red; font-size: 11pt;" *ngIf="formLogin.controls.cpf.errors?.required && submitErrado">
            Campo obrigatório
          </span>
          <span style="color: red; font-size: 11pt;" *ngIf="formLogin.controls.cpf.errors?.cpf && submitErrado">
            CPF inválido
          </span>
        </div>
      </div>

      <button type="submit">
        <span>
          Localizar cadastro
        </span>

        <div class="circle">
          <img *ngIf="!isLoading" src="https://redome.inca.gov.br/wp-content/uploads/2025/05/avancar.svg" alt="icone de avançar">
          <div *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        </div>
      </button>
    </form>
  </div>

  <div *ngSwitchCase="1" class="step">
    <h1 class="step-title">
      <b>Cadastro localizado!</b> <br>
      Preencha o formulário abaixo para manter seus dados atualizados.
    </h1>
    <form [formGroup]="formAtualizacao" (ngSubmit)="SubitAtualizacao()">
      <div>
        <div *ngIf="cpfValid == true || false">
          <h2 class="step-section-title">Seu CPF</h2>

          <div class="double">
            <div class="input-wrapper">
              <input autocomplete="false" autocomplete="chrome-off" class="form-control" formControlName="cpf"
                [dropSpecialCharacters]="false" mask="000.000.000-00" type="text" placeholder="999.999.999-99">
              <span style="color: red; font-size: 11pt;"
                *ngIf="formAtualizacao.controls.cpf.errors?.required && submitErrado">
                Campo obrigatório
              </span>
              <span style="color: red; font-size: 11pt;"
                *ngIf="formAtualizacao.controls.cpf.errors?.cpf && submitErrado">
                CPF inválido
              </span>
            </div>
          </div>
        </div>

        <h2 class="step-section-title">Endereço</h2>

        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="chrome-off" mask="00000-000" [dropSpecialCharacters]="false" formControlName="cep"
              (blur)="buscaCep($event.target.value)" type="text" placeholder="CEP" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.cep.errors?.required && submitErrado">
              Campo obrigatório
            </span>
            <span style="color: red; font-size: 11pt;" *ngIf="cepErrado ">
              Cep Inválido
            </span>
          </div>

          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" formControlName="endereco" id="logradouro"
              name="logradouro" type="text" placeholder="Endereço" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.endereco.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>
        </div>


        <div class="double">
          <div class="input-wrapper">
            <select formControlName="estado" class="form-select" (change)="changeEstado($event)">
              <option class="a1" value="" disabled selected>Estado</option>
              <option *ngFor="let estado of estados" [value]="estado.id">{{ estado.nome }}</option>
            </select>
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.estado.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>
          <div class="input-wrapper">
            <select formControlName="municipio" class="form-select">
              <option value="" disabled selected>Município</option>
              <option *ngFor="let municipio of municipios" [value]="municipio.id">{{ municipio.nome }}</option>
            </select>
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.municipio.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>
        </div>

        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" formControlName="bairro" type="text"
              placeholder="Bairro" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.bairro.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" mask="999999" formControlName="numero" type="text"
              placeholder="Número" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.numero.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>
        </div>

        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" SIZE=10 MAXLENGTH=20 formControlName="complemento"
              type="text" placeholder="Complemento" class="form-control">
          </div>
        </div>
      </div>

      <h2 class="step-section-title">Telefones</h2>

      <div class="double">
        <div class="input-wrapper">
          <input autocomplete="false" autocomplete="chrome-off" [dropSpecialCharacters]="false"
            mask="(00) 00000-0000 || (00) 0000-0000" formControlName="telefone1" type="text"
            placeholder="(21) 99999-9999" class="form-control">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formAtualizacao.controls.telefone1.errors?.required && submitErrado">
            Campo obrigatório
          </span>
          <span style="color: red; font-size: 11pt;" *ngIf="TelErrado && submitErrado">
            Número Inválido
          </span>
        </div>

        <div class="input-wrapper">
          <input autocomplete="false" autocomplete="chrome-off" formControlName="contato" type="text"
            placeholder="Nome Contato" class="form-control">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formAtualizacao.controls.contato.errors?.required && submitErrado">
            Campo obrigatório
          </span>
        </div>
      </div>

      <div *ngIf="intTel == 1 || intTel == 2">
        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" [dropSpecialCharacters]="false"
              mask="(00) 00000-0000 || (00) 0000-0000" formControlName="telefone2" type="text"
              placeholder="(21) 99999-9999" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.telefone2.errors?.required && submitErrado">
              Campo obrigatório
            </span>
            <span style="color: red; font-size: 11pt;" *ngIf="TelErrado && submitErrado">
              Número Inválido
            </span>
          </div>

          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" formControlName="contato_1" type="text"
              placeholder="Nome Contato" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.contato_1.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>

          <button class="delete-item" (click)="deletePhone()">
            <i class="ta-circulo-cancelado fs-20"></i>
          </button>
        </div>
      </div>

      <div *ngIf="intTel == 2">
        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" [dropSpecialCharacters]="false"
              mask="(00) 00000-0000 || (00) 0000-0000" formControlName="telefone3" type="text"
              placeholder="(21) 99999-9999" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.telefone3.errors?.required && submitErrado">
              Campo obrigatório
            </span>
            <span style="color: red; font-size: 11pt;" *ngIf="TelErrado1 && submitErrado">
              Número Inválido
            </span>
          </div>

          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" formControlName="contato_2" type="text"
              placeholder="Nome Contato" class="form-control">
            <span style="color: red; font-size: 11pt;"
              *ngIf="formAtualizacao.controls.contato_2.errors?.required && submitErrado">
              Campo obrigatório
            </span>
          </div>

          <button class="delete-item" (click)="deletePhone()">
            <i class="ta-circulo-cancelado fs-20"></i>
          </button>
        </div>
      </div>

      <div *ngIf="intTel != 2" class="add-mais" (click)="addPhone()">
        <i class="ta-circulo-soma"></i>
        <span>Adicionar mais</span>
      </div>

      <h2 class="step-section-title">E-mails</h2>

      <div class="double">
        <div class="input-wrapper">
          <input autocomplete="false" autocomplete="chrome-off" (change)="changeSpace($event.target.value, 1)" input
            type="text" formControlName="email1" placeholder="seuemail@email.com" class="form-control">
          <span style="color: red; font-size: 11pt;"
            *ngIf="formAtualizacao.controls.email1.errors?.required && submitErrado">
            Campo obrigatório
          </span>
          <span style="color: red; font-size: 11pt;" *ngIf="emailErrado && submitErrado">
            E-mail inválido
          </span>
        </div>
      </div>

      <div *ngIf="intEmail == 1 || intEmail == 2">
        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" (change)="changeSpace($event.target.value, 2)" input
              type="text" formControlName="email2" placeholder="seuemail@email.com" class="form-control">
            <span style="color: red; font-size: 11pt;" *ngIf="emailErrado1 && submitErrado">
              E-mail inválido
            </span>
          </div>

          <button class="delete-item" (click)="deleteEmail()">
            <i class="ta-circulo-cancelado fs-20"></i>
          </button>
        </div>
      </div>

      <div *ngIf="intEmail == 2">
        <div class="double">
          <div class="input-wrapper">
            <input autocomplete="false" autocomplete="chrome-off" (change)="changeSpace($event.target.value, 3)" input
              type="text" formControlName="email3" placeholder="seuemail@email.com" class="form-control">
            <span style="color: red; font-size: 11pt;" *ngIf="emailErrado2 && submitErrado">
              E-mail inválido
            </span>
          </div>

          <button class="delete-item" (click)="deleteEmail()">
            <i class="ta-circulo-cancelado fs-20"></i>
          </button>
        </div>
      </div>

      <div *ngIf="intEmail != 2" class="add-mais" (click)="addEmail()">
        <i class="ta-circulo-soma"></i>
        <span>Adicionar mais</span>
      </div>

      <button type="submit">
        <span>
          Atualizar cadastro
        </span>

        <div class="circle">
          <i class="bi bi-arrow-right" *ngIf="!isLoading"></i>
          <div *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        </div>
      </button>
    </form>
  </div>

  <div *ngSwitchCase="2" class="step">
    <h1 class="step-title">
      <b>Não conseguimos identificar seu cadastro.</b> <br>
      Por favor, entre em contato com o Hemocentro que coletou
      seus dados para verificar o que pode ter ocorrido.
    </h1>

    <div class="actions">
      <button class="btn btn-primary" (click)="tentarNovamente()">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Tentar novamente
      </button>
      <button onclick="window.open('http://redome.inca.gov.br/doador/hemocentros/', '_blank')"
        class="btn btn-primary">Listagem de hemocentros</button>
      <button onclick="window.open('http://redome.inca.gov.br/o-redome/contato/', '_blank')"
        class="btn btn-primary">Suporte Redome</button>
    </div>
  </div>

  <div *ngSwitchCase="3" class="step">
    <h1 class="step-title">
      <b>Atualização realizada com sucesso!</b> <br>
      Seus dados foram enviados para o banco de dados do REDOME.
    </h1>
  </div>
</div>